mutation updateFetchingWorker($version: String!, $type: String!) {
    updateFetchingWorker(version: $version, type: $type)
}
